import { render, staticRenderFns } from "./BoxNotification.vue?vue&type=template&id=7109b2db&scoped=true&"
import script from "./BoxNotification.vue?vue&type=script&lang=js&"
export * from "./BoxNotification.vue?vue&type=script&lang=js&"
import style0 from "./BoxNotification.vue?vue&type=style&index=0&id=7109b2db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7109b2db",
  null
  
)

component.options.__file = "BoxNotification.vue"
export default component.exports